var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94 466 c-16 -12 -20 -30 -24 -107 l-5 -93 -32 -8 c-42 -11 -42 -23 -1 -34 l33 -10 5 -91 c3 -51 10 -97 17 -104 15 -15 112 -26 98 -11 -5 6 -26 12 -45 14 l-35 3 -3 90 c-2 77 -5 92 -23 108 l-21 17 21 18 c18 15 21 30 23 107 l3 90 38 3 c20 2 37 7 37 13 0 14 -64 11 -86 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300 471 c0 -6 17 -11 38 -13 l37 -3 3 -90 c2 -77 5 -92 23 -107 l21 -18 -21 -17 c-18 -16 -21 -31 -23 -108 l-3 -90 -37 -3 c-21 -2 -38 -8 -38 -14 0 -14 78 -4 94 12 6 6 13 52 16 103 l5 91 33 10 c17 5 32 15 32 23 0 8 -4 12 -9 9 -5 -4 -21 -2 -35 4 -25 9 -26 12 -26 95 0 72 -3 88 -20 105 -21 21 -90 29 -90 11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.e9e0145cd878bc836c40a1957366df1c.svg";
export { ForwardRef as ReactComponent };